import { motion } from 'framer-motion';

import { styled } from '@/style';

// eslint-disable-next-line import/prefer-default-export
export const SymbolG = styled(motion.g)`
  mix-blend-mode: multiply;
  transition: slow;
`;
